import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { GazetteerSearchResult } from './gazetteer-search.model';
import { GazetteerSearchService } from './gazetteer-search.service';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-gazetteer-search',
  templateUrl: './gazetteer-search.component.html',
  styleUrls: ['./gazetteer-search.component.scss'],
})
export class GazetteerSearchComponent implements OnInit {
  @Output() selectedResult: EventEmitter<any> = new EventEmitter<any>();
  @Output() clearGazetteerResults: EventEmitter<any> = new EventEmitter<any>();
  $searchTermSubject: Subject<string> = new Subject<string>();
  onDestroy$ = new Subject();
  resultsClass: string = 'd-block';
  searchTerm: string = '';
  searchResults: GazetteerSearchResult;
  searching: boolean = false;
  searchNotFound = false;
  searchError = false;

  constructor(private gazetteerSearchService: GazetteerSearchService) {}

  ngOnInit(): void {
    this.$searchTermSubject
      .pipe(takeUntil(this.onDestroy$))
      .pipe(debounceTime(600))
      .subscribe((searchText) => {
        this.search();
      });
  }

  /**
   * @returns void
   */
  showResultsList(): void {
    this.resultsClass = 'd-block';
  }

  /**
   * @returns void
   */
  search(): void {
    this.searchError = false;
    this.searchNotFound = false;
    this.searching = true;
    this.gazetteerSearchService
      .search(this.searchTerm || null, 1)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.searchResults = data;
          /**
           * new empty array that unique results
           * will be pushed in to and filtered
           * every time a newResult is pushed in
           */
          const uniqueSearchResults = [];
          this.searchResults.results.map((newResult) =>
            uniqueSearchResults.filter(
              // enumerates over matches array
              (existing) =>
                existing.country_name === newResult.country_name &&
                existing.region_name === newResult.region_name &&
                existing.name === newResult.name,
            ).length > 0
              ? null
              : uniqueSearchResults.push(newResult),
          ); // pushes any unique result into uniqueSearchResults array
          this.searchResults.results = uniqueSearchResults;
          if (this.searchTerm.length && this.searchResults.results.length < 1) {
            this.searchNotFound = true;
          }
          this.searching = false;
        },
        (error) => {
          this.searchError = true;
          this.searching = false;
        },
      );
  }

  selectSearchResult(result: any): void {
    this.searchTerm = result.name;
    this.selectedResult.emit(result);
    this.hideResultsList();
  }

  hideResultsList(): void {
    this.resultsClass = 'd-none';
  }

  resetSearch(): void {
    this.clearGazetteerResults.emit();
    this.searchError = false;
    this.searchNotFound = false;
    this.searching = false;
    this.searchResults = null;
    this.searchTerm = '';
  }

  /**
   * Debounce Helper Mechanism
   * @param query
   */
  onFieldChange(query: string) {
    if (query.length > 0) {
      this.searching = true;
      this.showResultsList();
    } else {
      this.searching = false;
      this.hideResultsList();
      this.clearGazetteerResults.emit();
    }

    this.$searchTermSubject.next(query);
  }

  /**
   * @returns void
   */
  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
